module.exports = __webpack_public_path__ + "media/images/pbna-new-94337c0cf73c853569a400f594aea75b.png";